import { useEffect } from 'react';
/**
 * Hook that alerts clicks outside of the passed ref
 */

export function useOutsideAlerter(ref) {
  var setShowSelectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  useEffect(function () {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) setShowSelectedOptions(false);
    }

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}